import $ from 'jquery';
import { FireComponent } from '@component';

export class Faqs extends FireComponent {
	constructor(id) {
		super(id);
	}

	get elements() {
		return {
			$button: this.findElement('button'),
		};
	}

	_initCollapse() {
		this.elements.$button.on('click', function() {
			var icon = $(this).find('.faqs__plus');
			var collapse = $(this).parent().find('.faqs__collapse');
			var height = collapse.find('div').height() + 80;

			if ($(this).hasClass('open')) {
				$(this).removeClass('open');
				icon.text('+');
				collapse.removeClass('open').css('max-height', 0);
			} else {
				$(this).addClass('open');
				icon.text('-');
				collapse.addClass('open').css('max-height', height);
			}
		});
	}

	init() {
		if (!this.componentExists) return;
		this._initCollapse();
	}
}